import type { SVGProps } from "react";
const SenecPictogramLetter = (props: Pick<SVGProps<SVGSVGElement>, "color">) => (
    <svg width={48} height={48} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" {...props}>
        <path
            d="M5 9C3.34315 9 2 10.3431 2 12V30C2 30.5523 2.44772 31 3 31C3.55228 31 4 30.5523 4 30V12C4 11.4477 4.44772 11 5 11H43C43.5523 11 44 11.4477 44 12V36C44 36.5523 43.5523 37 43 37H5C4.44772 37 4 36.5523 4 36V35C4 34.4477 3.55228 34 3 34C2.44772 34 2 34.4477 2 35V36C2 37.6569 3.34315 39 5 39H43C44.6569 39 46 37.6569 46 36V12C46 10.3431 44.6569 9 43 9H5Z"
            fill="currentColor"
        />
        <path
            d="M9.58281 15.0243C9.13402 14.7024 8.50927 14.8053 8.18739 15.2541C7.86551 15.7029 7.9684 16.3276 8.41719 16.6495L23.0572 27.1495C23.4056 27.3994 23.8744 27.3994 24.2228 27.1495L38.8628 16.6495C39.3116 16.3276 39.4145 15.7029 39.0926 15.2541C38.7707 14.8053 38.146 14.7024 37.6972 15.0243L23.64 25.1063L9.58281 15.0243Z"
            fill="currentColor"
        />
    </svg>
);
export default SenecPictogramLetter;
